import {FormGroup} from '@angular/forms';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'countErrors',
  standalone: true,
})
export class CountErrorsPipe implements PipeTransform {
  transform(errorList: {field: string; errors: string[]}[], formGroup: FormGroup): number {
    return errorList.reduce((num, el) => {
      const add = formGroup.get(el.field)?.touched ? el.errors.length : 0;
      return num + add;
    }, 0);
  }
}
